<template>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <b-row>
      <b-col md="4">
        <b-card
          header="Catalog tree"
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <div slot="header">
            <span data-font="22">Catalog</span>
          </div>

          <!--  <b-row>
           <b-col>
              <a-input-search
                style="margin-bottom: 8px"
                placeholder="Search"
                @change="onChange"
            /></b-col> -->
          <!-- <b-col cols="2">
                <b-button
                  size="sm"
                  variant="primary"
                  @click="refreshAllData"
                  :disabled="isLoadingRefresh"
                >
                  <span
                    v-if="isLoadingRefresh"
                    class="fa fa-refresh fa-spin"
                    style="font-size:15px"
                  />
                  <span v-else class="fa fa-refresh" style="font-size:15px" />
                </b-button>
              </b-col> 
          </b-row>-->
          <a-tree
            v-if="treeData.length > 0"
            :checkable="checkable"
            v-model="checkedKeys"
            @select="onSelect"
            :load-data="onLoadData"
            :treeData="treeData"
          />
        </b-card>
      </b-col>
      <b-col md="8" v-if="selectedCatalogObject">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <div slot="header">
            <span data-font="22">Catalog Details</span>
            <button
              class="btn float-right ml-2 btn-danger mr-2"
              :disabled="iscreateButtonDisable"
              v-if="
                userPermission.hasOwnProperty('DELETE_CATALOG') && !iscreateButtonDisable
              "
              @click="deleteCatalog"
            >
              <span class="font-weight-bold">Delete Catalog</span>
            </button>
            <router-link :to="{ name: 'CatalogDetails', params: { id: catalog } }">
              <button
                class="btn float-right btn-success"
                v-if="userPermission.hasOwnProperty('CATALOG_DETAIL')"
              >
                <span class="font-weight-bold">Details</span>
              </button>
            </router-link>

            <button
              class="btn float-right btn-success mr-2"
              :disabled="iscreateButtonDisable"
              v-if="userPermission.hasOwnProperty('CREATE_CATALOG')"
              @click="$router.push({ path: '/catalog/create' })"
            >
              <span class="font-weight-bold">Create Catalog</span>
            </button>
          </div>
          <b-row class="font-md p-2">
            <b-col md="4">
              <span>Name</span>
            </b-col>
            <b-col md="8">
              <input
                class="form-control"
                :disabled="disabled"
                :value="selectedCatalogObject.name"
              />
            </b-col>
          </b-row>

          <b-row class="font-md p-2">
            <b-col md="4">
              <span>Catalog Type</span>
            </b-col>
            <b-col md="8">
              <input
                class="form-control"
                :disabled="disabled"
                :value="selectedCatalogObject.catalogType"
              />
            </b-col>
          </b-row>

          <b-row class="font-md p-2">
            <b-col md="4">
              <span>Display Name</span>
            </b-col>
            <b-col md="8">
              <input
                class="form-control"
                :disabled="disabled"
                :value="selectedCatalogObject.catalogDescription.displayName"
              />
            </b-col>
          </b-row>

          <b-row class="font-md p-2">
            <b-col md="4">
              <span>Long Description</span>
            </b-col>
            <b-col md="8">
              <input
                class="form-control"
                :disabled="disabled"
                :value="selectedCatalogObject.catalogDescription.longDescription"
              />
            </b-col>
          </b-row>

          <b-row class="font-md p-2">
            <b-col md="4">
              <span>Short Description</span>
            </b-col>
            <b-col md="8">
              <input
                class="form-control"
                :disabled="disabled"
                :value="selectedCatalogObject.catalogDescription.shortDescription"
              />
            </b-col>
          </b-row>

          <b-row class="font-md p-2">
            <b-col md="4">
              <span>Attribute Count</span>
            </b-col>
            <b-col md="8">
              <input
                class="form-control"
                :disabled="disabled"
                :value="selectedCatalogObject.externalAttributes.length"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import loader from "@/components/loader/nipigeloader.vue";
import { mapGetters } from "vuex";

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

export default {
  name: "Catalog",
  components: {
    loader: loader,
  },
  data: () => {
    return {
      loading: false,
      isLoadingRefresh: false,
      iscreateButtonDisable: false,
      search: "",

      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      treeData: [],
      disabled: true,
      checkable: false,
      selectedCatalogObject: {
        catalogDescription: {
          displayName: "",
          longDescription: "",
          shortDescription: "",
        },
        externalAttributes: [],
      },
    };
  },
  methods: {
    onLoadData(event) {
      console.log(event.dataRef);
      return new Promise((resolve) => {
        if (event.dataRef.children.length > 0) {
          resolve();
          return;
        } else {
          if (!event.dataRef.isProductType) {
            let searchString = event.dataRef.isRoot
              ? `isDomain=y&parent=${event.dataRef._id}`
              : `parent=${event.dataRef._id}`;
            this.$store
              .dispatch("catalog/fetchCatalogList", searchString)
              .then((result) => {
                if (result.data.status === 1) {
                  const dataArray = result.data.response;
                  if (dataArray && dataArray.length > 0) {
                    dataArray.map((obj) => {
                      event.dataRef.children.push({
                        ...obj,
                        title: obj.name,
                        key: obj._id,
                        children: [],
                        isLeaf: obj.isProductType,
                      });
                    });
                    this.$store.dispatch("catalog/updateCatalogTree", this.treeData);
                  }
                }

                console.log(this.treeData);
                resolve();
              });
          }
        }
      });
    },
    async generateTree() {
      // it prepares a node structure necessary to render a tree view
      const makeNode = (catalog) => ({
        title: catalog.name,
        key: catalog._id,
        children: [],
        ...catalog,
      });
      // if updated tree available in vuex
      console.log(this.generatedTreeData);
      if (this.generatedTreeData.length > 0) {
        this.treeData = this.generatedTreeData;
        this.loading = false;
      } else {
        let searchString = "isRoot=y";
        this.$store.dispatch("catalog/fetchCatalogList", searchString).then((result) => {
          this.loading = false;
          if (result.data.status === 1) {
            const dataArray = result.data.response;
            if (dataArray && dataArray.length > 0) {
              let rootCatalog = makeNode(dataArray[0]);
              this.treeData = [];
              this.treeData = [rootCatalog];
              this.$store.dispatch("catalog/updateCatalogTree", this.treeData);
            }
          }
        });
      }
      this.isLoadingRefresh = false;
    },
    onSelect(event, data) {
      this.selectedCatalogObject = data.node.dataRef;
      this.selectedCatalogObject.catalogType = data.node.dataRef.isCategory
        ? "Catalog layer"
        : data.node.dataRef.isDomain
        ? "Domain layer"
        : data.node.dataRef.isMarket
        ? "Market layer"
        : data.node.dataRef.isProductType
        ? "Product layer"
        : data.node.dataRef.isRoot
        ? "Root layer"
        : "";
    },
    onChange(e) {
      console.log(e);
      const value = e.target.value;
      const expandedKeys = this.treeData
        .map((item) => {
          if (item.key.indexOf(value) > -1) {
            return getParentKey(item.key, this.treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true,
      });
    },
    deleteCatalog() {
      this.$swal({
        title: "Delete this Catalog?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("catalog/deleteCatalog", this.selectedCatalogObject._id)
            .then((result) => {
              this.$toasted.success("Catalog Deleted Successfully");
              this.getUpdatedCatalog();
            });
        }
      });
    },
    async getUpdatedCatalog() {
      this.loading = true;
      this.generateTree();
    },
    async refreshAllData() {
      this.isLoadingRefresh = true;
      this.$store.dispatch("catalog/updateCatalogTree", []);
      this.generateTree();
    },
  },
  mounted: async function () {
    this.loading = true;
    this.provider = await this.$store.getters["auth/getUserID"];
    this.generateTree();
  },
  computed: {
    ...mapGetters({
      generatedTreeData: "catalog/GetGeneratedCatalog",
    }),
    catalog() {
      return this.selectedCatalogObject ? this.selectedCatalogObject._id : null;
    },
    totalRows() {
      return this.getRowCount();
    },
    captions() {
      return this.fields;
    },
    userPermission() {
      return this.$store.getters["auth/getUserPermissions"];
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
